var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"need-details mt-4"},[_c('h3',{staticClass:"text-center"},[_vm._v("Health Notes")]),_c('ul',_vm._l((_vm.selectedDisease),function(key,k){return _c('li',{key:k},[_vm._v(" "+_vm._s(_vm.diseaseDetails(key))+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }